import axios from 'axios'

export const sendForm = values =>
  axios.post(location.href, values, {
    headers: {
      'content-type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
